export default "__VITE_ASSET__3500a626__"